module.exports = __webpack_public_path__ + "static/media/general-icons.03f55bed4c15aea3e2f748a8de86c0e18b1505301e4ac954d37942ecb67eb916.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/general-icons.woff2
// module id = 2365
// module chunks = 204